'use client';

import { useState } from 'react';

import type { ProductListItemType} from '@zoomit/web-kit';
import { useHistoryState } from '@zoomit/web-kit';

export const useProductInfoSheet = () => {
  const modalStates = useHistoryState<boolean>({
    id: 'product-info-modal',
    initialState: false,
  });

  const [productInfo, setProductInfo] = useState<ProductListItemType>();

  const handleSetProductInfoAndOpen = (info: ProductListItemType) => {
    setProductInfo(info);
    modalStates.open();
  };

  const handleClose = () => {
    setProductInfo(undefined);
    modalStates.close();
  };

  return {
    isOpen: modalStates.isOpen && !!productInfo,
    handleClose,
    productInfo: productInfo!,
    handleSetProductInfoAndOpen,
  };
};
